<fin-continue-reading>
  <ng-content />
</fin-continue-reading>
